/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SimilarPerson/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Lead from './Lead/index'
import Person from './Person/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SimilarPerson({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/SimilarPatients/Content/Content/SimilarPerson"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'Lead'
let similarPersonTypeValueData = fromData.useDataValue({ viewPath,
context: 'similar_person',
path: 'type',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: similarPersonTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'Lead'}>
<Lead
  viewPath={`${viewPath}/Lead`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Person'}>
<Person
  viewPath={`${viewPath}/Person`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}